import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Download, Printer } from 'lucide-react';

const ViewPoliceVerificationModal = ({ isOpen, onClose, verification }) => {
  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    const printWindow = window.open('', '', 'height=800,width=800');
    printWindow.document.write('<html><head><title>Police Verification Request</title>');
    printWindow.document.write('<style>body{font-family:Arial,sans-serif;padding:40px;line-height:1.6;}.header{text-align:center;margin-bottom:30px;}.logo{width:80px;height:80px;margin:0 auto 10px;}.title{font-size:18px;font-weight:bold;text-decoration:underline;margin:10px 0;}.section{margin:20px 0;}.label{font-weight:600;}.value{margin-left:10px;}.hindi{color:#666;font-size:12px;}</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(document.getElementById('verification-content').innerHTML);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto" style={{backgroundColor: '#fff'}}>
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>Police Verification Request - {verification.tenant_name}</span>
            <div className="flex gap-2">
              <Button
                onClick={handleDownload}
                size="sm"
                variant="outline"
                className="border-blue-600 text-blue-600"
              >
                <Download size={16} className="mr-1" />
                Download
              </Button>
              <Button
                onClick={handlePrint}
                size="sm"
                variant="outline"
                className="border-green-600 text-green-600"
              >
                <Printer size={16} className="mr-1" />
                Print
              </Button>
            </div>
          </DialogTitle>
        </DialogHeader>

        <div id="verification-content" className="space-y-4 p-8 bg-white" style={{fontFamily: 'Arial, sans-serif', fontSize: '14px', lineHeight: '1.6'}}>
          {/* Header with Logo */}
          <div style={{textAlign: 'center', marginBottom: '30px'}}>
            <div style={{width: '80px', height: '80px', margin: '0 auto 15px', border: '3px solid #1e40af', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#eff6ff'}}>
              <div style={{textAlign: 'center', fontSize: '10px', fontWeight: 'bold', color: '#1e40af'}}>
                <div>HARYANA</div>
                <div>POLICE</div>
                <div style={{fontSize: '8px', marginTop: '2px'}}>सुरक्षा सहयोग</div>
              </div>
            </div>
            <h2 style={{fontSize: '16px', fontWeight: 'bold', margin: '10px 0', color: '#1e40af'}}>HARYANA POLICE GENERAL VERIFICATION SERVICES</h2>
            <h3 style={{fontSize: '14px', fontWeight: 'bold', textDecoration: 'underline', margin: '10px 0'}}>TENANT VERIFICATION REQUEST</h3>
            <p style={{fontSize: '12px', color: '#666'}}>किरायेदार सत्यापन अनुरोध</p>
          </div>

          {/* Service Details */}
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px', padding: '15px', backgroundColor: '#f3f4f6', borderRadius: '8px'}}>
            <div>
              <span style={{fontWeight: '600'}}>District (जिला): </span>
              <span>{verification.district}</span>
            </div>
            <div>
              <span style={{fontWeight: '600'}}>Office Name (कार्यालय का नाम): </span>
              <span>{verification.office_name}</span>
            </div>
            <div>
              <span style={{fontWeight: '600'}}>Service Request No: </span>
              <span style={{color: '#1e40af', fontWeight: 'bold'}}>{verification.service_request_no}</span>
            </div>
            <div>
              <span style={{fontWeight: '600'}}>Service Request Status: </span>
              <span style={{backgroundColor: '#10b981', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '12px'}}>{verification.status}</span>
            </div>
          </div>

          {/* Owner Information */}
          <div style={{marginBottom: '25px'}}>
            <h4 style={{fontSize: '15px', fontWeight: 'bold', backgroundColor: '#1e40af', color: 'white', padding: '8px 12px', borderRadius: '6px', marginBottom: '15px'}}>Owner Information (मालिक का विवरण)</h4>
            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', paddingLeft: '15px'}}>
              <div>
                <span style={{fontWeight: '600'}}>Name (नाम): </span>
                <span>{verification.owner_name}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Email ID (ईमेल): </span>
                <span>{verification.owner_email || '-'}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Mobile No. (मोबाइल नंबर): </span>
                <span>{verification.owner_mobile}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Landline No. (लैंडलाइन नंबर): </span>
                <span>{verification.owner_landline || '-'}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Occupation (व्यवसाय): </span>
                <span>{verification.owner_occupation}</span>
              </div>
              <div className="col-span-2">
                <span style={{fontWeight: '600'}}>Address (पता): </span>
                <span>{verification.owner_address}</span>
              </div>
            </div>
          </div>

          {/* Tenant Information */}
          <div style={{marginBottom: '25px'}}>
            <h4 style={{fontSize: '15px', fontWeight: 'bold', backgroundColor: '#1e40af', color: 'white', padding: '8px 12px', borderRadius: '6px', marginBottom: '15px'}}>Tenant Information (किरायेदार का विवरण)</h4>
            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', paddingLeft: '15px'}}>
              <div>
                <span style={{fontWeight: '600'}}>Name (नाम): </span>
                <span>{verification.tenant_name}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Date of Birth (जन्म तिथि): </span>
                <span>{verification.tenant_dob}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Mobile No. (मोबाइल नंबर): </span>
                <span>{verification.tenant_mobile}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Landline No. (लैंडलाइन नंबर): </span>
                <span>{verification.tenant_landline || '-'}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Gender (लिंग): </span>
                <span>{verification.tenant_gender === 'M' ? 'Male (पुरुष)' : verification.tenant_gender === 'F' ? 'Female (महिला)' : 'Other (अन्य)'}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Relation Type (संबंध प्रकार): </span>
                <span>{verification.tenant_relation_type}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Relative Name(s) (रिश्तेदार का नाम): </span>
                <span>{verification.tenant_relative_name}</span>
              </div>
              {verification.tenant_relative_name_1 && (
                <div>
                  <span style={{fontWeight: '600'}}>Relative Name 1: </span>
                  <span>{verification.tenant_relative_name_1}</span>
                </div>
              )}
              {verification.tenant_relative_name_2 && (
                <div>
                  <span style={{fontWeight: '600'}}>Relative Name 2: </span>
                  <span>{verification.tenant_relative_name_2}</span>
                </div>
              )}
              <div>
                <span style={{fontWeight: '600'}}>Purpose for Tenancy (किरायेदारी का उद्देश्य): </span>
                <span>{verification.tenant_purpose}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>Occupation (व्यवसाय): </span>
                <span>{verification.tenant_occupation}</span>
              </div>
              {verification.tenant_emergency_contact_name && (
                <div>
                  <span style={{fontWeight: '600'}}>Emergency Contact Name: </span>
                  <span>{verification.tenant_emergency_contact_name}</span>
                </div>
              )}
              {verification.tenant_emergency_contact_number && (
                <div>
                  <span style={{fontWeight: '600'}}>Emergency Contact Number: </span>
                  <span>{verification.tenant_emergency_contact_number}</span>
                </div>
              )}
            </div>

            <div style={{marginTop: '15px', paddingLeft: '15px'}}>
              <div style={{marginBottom: '10px'}}>
                <span style={{fontWeight: '600'}}>Present Address (वर्तमान पता): </span>
                <div style={{marginLeft: '20px', marginTop: '5px', padding: '10px', backgroundColor: '#f9fafb', borderRadius: '4px'}}>
                  {verification.tenant_present_address}
                </div>
              </div>
              <div style={{marginBottom: '10px'}}>
                <span style={{fontWeight: '600'}}>Permanent Address (स्थायी पता): </span>
                <div style={{marginLeft: '20px', marginTop: '5px', padding: '10px', backgroundColor: '#f9fafb', borderRadius: '4px'}}>
                  {verification.tenant_permanent_address}
                </div>
              </div>
              {verification.tenant_previous_address && (
                <div>
                  <span style={{fontWeight: '600'}}>Previous Address (पिछला पता): </span>
                  <div style={{marginLeft: '20px', marginTop: '5px', padding: '10px', backgroundColor: '#f9fafb', borderRadius: '4px'}}>
                    {verification.tenant_previous_address}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Verification Questions */}
          <div style={{marginBottom: '25px', padding: '20px', backgroundColor: '#fef3c7', borderRadius: '8px', border: '2px solid #f59e0b'}}>
            <h4 style={{fontSize: '15px', fontWeight: 'bold', marginBottom: '15px', color: '#92400e'}}>Verification Details (सत्यापन विवरण)</h4>
            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px'}}>
              <div>
                <span style={{fontWeight: '600'}}>Does the tenant or any family member have any criminal records? </span>
                <div style={{color: '#666', fontSize: '12px', marginBottom: '5px'}}>(क्या किरायेदार या किसी परिवार के सदस्य के पास कोई आपराधिक रिकॉर्ड है?)</div>
                <span style={{backgroundColor: verification.criminal_records === 'Y' ? '#ef4444' : '#10b981', color: 'white', padding: '4px 12px', borderRadius: '4px', fontWeight: 'bold'}}>{verification.criminal_records}</span>
              </div>
              <div>
                <span style={{fontWeight: '600'}}>All the information provided in the form is true? </span>
                <div style={{color: '#666', fontSize: '12px', marginBottom: '5px'}}>(फॉर्म में दी गई सभी जानकारी सत्य है?)</div>
                <span style={{backgroundColor: verification.information_true === 'Yes' ? '#10b981' : '#ef4444', color: 'white', padding: '4px 12px', borderRadius: '4px', fontWeight: 'bold'}}>{verification.information_true}</span>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div style={{marginTop: '40px', paddingTop: '20px', borderTop: '2px solid #e5e7eb', textAlign: 'center', fontSize: '12px', color: '#666'}}>
            <p style={{fontWeight: '600', marginBottom: '5px'}}>This is a computer-generated document via RentKollect</p>
            <p>For any queries, please contact the respective Police Station</p>
            <p style={{marginTop: '10px', fontSize: '11px', color: '#999'}}>Generated on: {new Date(verification.created_at).toLocaleString('en-IN')}</p>
          </div>
        </div>

        <div className="flex gap-4 pt-4">
          <Button onClick={onClose} variant="outline" className="flex-1">
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewPoliceVerificationModal;